import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryDropdown from '@/components/feature/CategoryDropdown';
import CategoryGrid from '@/components/feature/CategoryGrid';
import FAQ from '@/components/feature/FAQ';

const articles = [
  {
    title: 'article_spreadsheet_guide',
    desc: 'article_spreadsheet_guide_desc',
    href: '/cssbuy-spreadsheet',
    icon: 'ri-table-line',
    color: 'bg-primary-100 text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20spreadsheet%20data%20table%20with%20product%20listing%20rows%20and%20category%20columns%20displayed%20on%20a%20modern%20computer%20screen%2C%20bright%20clean%20interface%20design%2C%20soft%20mint%20green%20accents%2C%20minimal%20flat%20illustration%20style%2C%20fresh%20modern%20aesthetic&width=600&height=400&seq=article-001&orientation=landscape&nocache=true',
  },
  {
    title: 'article_review',
    desc: 'article_review_desc',
    href: '/reviews',
    icon: 'ri-star-line',
    color: 'bg-accent-100 text-accent-600',
    img: 'https://readdy.ai/api/search-image?query=Set%20of%20five%20golden%20star%20rating%20icons%20with%20a%20review%20checklist%20card%2C%20clean%20pastel%20peach%20background%2C%20minimal%20flat%20illustration%20style%2C%20bright%20modern%20editorial%20aesthetic&width=600&height=400&seq=article-002&orientation=landscape&nocache=true',
  },
  {
    title: 'article_shipping',
    desc: 'article_shipping_desc',
    href: '/shipping',
    icon: 'ri-truck-line',
    color: 'bg-secondary-100 text-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20with%20packing%20tape%20and%20a%20small%20delivery%20truck%20icon%2C%20soft%20blue%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20clean%20modern%20logistics%20concept&width=600&height=400&seq=article-003&orientation=landscape&nocache=true',
  },
  {
    title: 'article_qc',
    desc: 'article_qc_desc',
    href: '/qc',
    icon: 'ri-camera-lens-line',
    color: 'bg-primary-100 text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=Large%20magnifying%20glass%20examining%20a%20folded%20t-shirt%20fabric%20detail%2C%20soft%20green%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20clean%20quality%20control%20concept&width=600&height=400&seq=article-004&orientation=landscape&nocache=true',
  },
  {
    title: 'article_warehouse',
    desc: 'article_warehouse_desc',
    href: '/guides',
    icon: 'ri-archive-line',
    color: 'bg-secondary-100 text-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=Warehouse%20storage%20shelves%20filled%20with%20cardboard%20boxes%20and%20packages%2C%20soft%20warm%20beige%20background%2C%20minimal%20flat%20illustration%20style%2C%20clean%20organized%20logistics%20concept&width=600&height=400&seq=article-005&orientation=landscape',
  },
  {
    title: 'article_coupon',
    desc: 'article_coupon_desc',
    href: '/guides',
    icon: 'ri-coupon-3-line',
    color: 'bg-accent-100 text-accent-600',
    img: 'https://readdy.ai/api/search-image?query=Discount%20coupon%20ticket%20with%20scissors%20cut%20line%20and%20percentage%20tag%2C%20soft%20coral%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20fresh%20savings%20concept&width=600&height=400&seq=article-006&orientation=landscape',
  },
  {
    title: 'article_legit',
    desc: 'article_legit_desc',
    href: '/reviews',
    icon: 'ri-shield-check-line',
    color: 'bg-primary-100 text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=Shield%20with%20green%20checkmark%20and%20lock%20icon%2C%20soft%20lavender%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20clean%20trust%20and%20security%20concept&width=600&height=400&seq=article-007&orientation=landscape',
  },
  {
    title: 'article_beginners',
    desc: 'article_beginners_desc',
    href: '/cssbuy-spreadsheet',
    icon: 'ri-book-open-line',
    color: 'bg-secondary-100 text-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=Step%20by%20step%20guide%20with%20numbered%20circles%20and%20arrows%2C%20soft%20yellow%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20fresh%20beginner%20tutorial%20concept&width=600&height=400&seq=article-008&orientation=landscape',
  },
  {
    title: 'article_buying',
    desc: 'article_buying_desc',
    href: '/guides',
    icon: 'ri-shopping-cart-2-line',
    color: 'bg-accent-100 text-accent-600',
    img: 'https://readdy.ai/api/search-image?query=Shopping%20cart%20filled%20with%20clothing%20items%20and%20a%20hand%20clicking%20buy%20button%2C%20soft%20mint%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20clean%20online%20shopping%20concept&width=600&height=400&seq=article-009&orientation=landscape',
  },
  {
    title: 'article_methods',
    desc: 'article_methods_desc',
    href: '/shipping',
    icon: 'ri-route-line',
    color: 'bg-primary-100 text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=Three%20different%20delivery%20route%20lines%20with%20arrows%20pointing%20to%20a%20globe%2C%20soft%20blue%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20shipping%20methods%20concept&width=600&height=400&seq=article-010&orientation=landscape',
  },
  {
    title: 'article_qc_checklist',
    desc: 'article_qc_checklist_desc',
    href: '/qc',
    icon: 'ri-checkbox-multiple-line',
    color: 'bg-secondary-100 text-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=Checklist%20clipboard%20with%20green%20checkmarks%20and%20product%20image%20thumbnail%2C%20soft%20peach%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20quality%20checklist%20concept&width=600&height=400&seq=article-011&orientation=landscape',
  },
  {
    title: 'article_seller',
    desc: 'article_seller_desc',
    href: '/guides',
    icon: 'ri-user-star-line',
    color: 'bg-accent-100 text-accent-600',
    img: 'https://readdy.ai/api/search-image?query=Verified%20seller%20profile%20card%20with%20star%20rating%20and%20shield%20badge%2C%20soft%20green%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20trust%20concept&width=600&height=400&seq=article-012&orientation=landscape',
  },
  {
    title: 'article_safety_guide',
    desc: 'article_safety_guide_desc',
    href: '/safety',
    icon: 'ri-shield-flash-line',
    color: 'bg-primary-100 text-primary-600',
    img: 'https://readdy.ai/api/search-image?query=Padlock%20with%20shield%20and%20warning%20icons%2C%20soft%20rose%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20account%20security%20concept&width=600&height=400&seq=article-013&orientation=landscape',
  },
  {
    title: 'article_faq_guide',
    desc: 'article_faq_guide_desc',
    href: '/faq',
    icon: 'ri-question-line',
    color: 'bg-secondary-100 text-secondary-600',
    img: 'https://readdy.ai/api/search-image?query=Question%20mark%20with%20speech%20chat%20bubbles%2C%20soft%20blue%20pastel%20background%2C%20minimal%20flat%20illustration%20style%2C%20faq%20concept&width=600&height=400&seq=article-014&orientation=landscape',
  },
];

export default function Home() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar transparent={true} />

      {/* Hero Section */}
      <section className="relative min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Vibrant%20fashion%20ecommerce%20collage%20with%20colorful%20sneakers%2C%20jackets%2C%20handbags%20and%20accessories%20arranged%20on%20soft%20pastel%20gradient%20background%2C%20bright%20studio%20lighting%2C%20premium%20editorial%20product%20photography%2C%20fresh%20modern%20aesthetic%2C%20diverse%20streetwear%20items&width=1600&height=900&seq=hero-001&orientation=landscape&nocache=true"
            alt="CSSBuy Spreadsheet Product Hub"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-24 pb-12 text-center">
          <span className="inline-block px-4 py-1.5 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-full text-xs md:text-sm font-medium text-background-50 uppercase tracking-widest mb-6">
            {t('hero_eyebrow')}
          </span>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 max-w-4xl mx-auto leading-tight mb-4">
            {t('hero_title')}
          </h1>
          <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            {t('hero_subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-external-link-line mr-2"></i>
              {t('cta_explore')}
            </a>
            <a
              href="/cssbuy-spreadsheet"
              className="inline-flex items-center px-6 py-3 bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 hover:bg-background-50/20 font-medium rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-book-open-line mr-2"></i>
              {t('cta_guide')}
            </a>
          </div>

          <div className="mt-10">
            <CategoryDropdown />
          </div>
        </div>
      </section>

      {/* Trust Strip */}
      <section className="bg-background-100 border-b border-background-200/70">
        <div className="w-full px-4 md:px-6 lg:px-10 py-4 md:py-5">
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-shield-check-line text-accent-500 text-base"></i>
              <span className="font-medium">{t('trust_independent')}</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-folder-chart-line text-accent-500 text-base"></i>
              <span className="font-medium">{t('trust_organized')}</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-refresh-line text-accent-500 text-base"></i>
              <span className="font-medium">{t('trust_updated')}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              {t('categories_title')}
            </h2>
            <p className="text-foreground-600 max-w-xl mx-auto">
              {t('categories_subtitle')}
            </p>
          </div>
          <CategoryGrid />
        </div>
      </section>

      {/* What is CSSBuy Spreadsheet */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-100">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider mb-2 block">
              CSSBuy Spreadsheet
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              {t('what_is_title')}
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              {t('what_is_text')}
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors whitespace-nowrap"
              >
                {t('cta_cssbuy_spreadsheet')}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-5 py-2.5 border-2 border-primary-500 text-primary-600 hover:bg-primary-50 font-medium rounded-md transition-colors whitespace-nowrap"
              >
                {t('cta_buy_now')}
              </a>
            </div>
          </div>
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-sm">
              <img
                src="https://readdy.ai/api/search-image?query=Laptop%20computer%20displaying%20colorful%20spreadsheet%20data%20table%20with%20product%20listings%2C%20coffee%20cup%20and%20notebook%20on%20clean%20white%20desk%2C%20bright%20airy%20workspace%2C%20soft%20natural%20daylight%2C%20modern%20productivity%20concept&width=800&height=600&seq=whatis-001&orientation=landscape&nocache=true"
                alt="CSSBuy Spreadsheet Guide"
                className="w-full h-64 md:h-80 object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 md:-left-6 bg-accent-500 text-background-50 px-4 py-2 rounded-lg shadow-sm">
              <span className="text-sm font-semibold">CSSBuy Spreadsheet</span>
            </div>
          </div>
        </div>
      </section>

      {/* Value Propositions */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              {t('value_title')}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {[
              { icon: 'ri-table-line', text: 'value_spreadsheet', color: 'bg-primary-100 text-primary-600' },
              { icon: 'ri-camera-lens-line', text: 'value_qc', color: 'bg-accent-100 text-accent-600' },
              { icon: 'ri-truck-line', text: 'value_shipping', color: 'bg-secondary-100 text-secondary-600' },
              { icon: 'ri-archive-line', text: 'value_warehouse', color: 'bg-primary-100 text-primary-600' },
              { icon: 'ri-star-line', text: 'value_review', color: 'bg-accent-100 text-accent-600' },
              { icon: 'ri-shield-check-line', text: 'value_safety', color: 'bg-secondary-100 text-secondary-600' },
            ].map((item, idx) => (
              <div key={idx} className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-colors">
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${item.color} flex items-center justify-center mb-4`}>
                  <i className={`${item.icon} text-lg md:text-xl`}></i>
                </div>
                <p className="text-sm md:text-base text-foreground-700">{t(item.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              {t('how_title')}
            </h2>
          </div>
          <div className="space-y-4">
            {[
              'how_step1', 'how_step2', 'how_step3', 'how_step4',
              'how_step5', 'how_step6', 'how_step7',
            ].map((step, idx) => (
              <div key={idx} className="flex items-start gap-4 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-sm md:text-base font-bold text-background-50">{idx + 1}</span>
                </div>
                <p className="text-sm md:text-base text-foreground-700 pt-1.5 md:pt-2">{t(step)}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-8">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors whitespace-nowrap"
            >
              {t('how_cta')}
            </a>
          </div>
        </div>
      </section>

      {/* Articles Section */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              {t('articles_title')}
            </h2>
            <p className="text-foreground-600 max-w-xl mx-auto">
              {t('articles_subtitle')}
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {articles.map((article) => (
              <a
                key={article.href + article.title}
                href={article.href}
                className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300"
              >
                <div className="h-40 md:h-44 overflow-hidden">
                  <img
                    src={article.img}
                    alt={t(article.title)}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className={`w-8 h-8 rounded-md ${article.color} flex items-center justify-center mb-3`}>
                    <i className={`${article.icon} text-sm`}></i>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {t(article.title)}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-2 mb-4">
                    {t(article.desc)}
                  </p>
                  <span className="inline-flex items-center text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                    {t('read_article')}
                    <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Shipping Section */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-100">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden shadow-sm">
              <img
                src="https://readdy.ai/api/search-image?query=Stack%20of%20cardboard%20shipping%20boxes%20with%20packing%20tape%20and%20delivery%20labels%2C%20small%20potted%20plant%20beside%20them%2C%20bright%20clean%20studio%2C%20soft%20pastel%20background%2C%20modern%20logistics%20concept%20photography&width=800&height=600&seq=shipping-001&orientation=landscape&nocache=true"
                alt="CSSBuy Shipping Guide"
                className="w-full h-64 md:h-80 object-cover"
              />
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <span className="text-sm font-semibold text-secondary-500 uppercase tracking-wider mb-2 block">
              Shipping
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              {t('shipping_title')}
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              {t('shipping_text')}
            </p>
            <a
              href="/shipping"
              className="inline-flex items-center px-5 py-2.5 bg-secondary-500 hover:bg-secondary-600 text-background-50 font-medium rounded-md transition-colors whitespace-nowrap"
            >
              {t('shipping_cta')}
            </a>
          </div>
        </div>
      </section>

      {/* Safety Section */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-100 text-accent-600 flex items-center justify-center mx-auto mb-6">
            <i className="ri-shield-check-line text-2xl md:text-3xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            {t('safety_title')}
          </h2>
          <p className="text-foreground-600 leading-relaxed mb-8 max-w-2xl mx-auto">
            {t('safety_text')}
          </p>
          <a
            href="/safety"
            className="inline-flex items-center px-5 py-2.5 bg-accent-500 hover:bg-accent-600 text-background-50 font-medium rounded-md transition-colors whitespace-nowrap"
          >
            {t('safety_cta')}
          </a>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              {t('faq_title')}
            </h2>
          </div>
          <FAQ />
          <div className="text-center mt-8">
            <a
              href="/faq"
              className="inline-flex items-center px-5 py-2.5 border-2 border-foreground-300 text-foreground-800 hover:bg-background-100 font-medium rounded-md transition-colors whitespace-nowrap"
            >
              {t('faq_cta')}
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            {t('final_cta_title')}
          </h2>
          <p className="text-foreground-600 mb-8 max-w-xl mx-auto">
            {t('final_cta_text')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors whitespace-nowrap"
            >
              {t('final_cta_explore')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3 border-2 border-primary-500 text-primary-600 hover:bg-primary-50 font-medium rounded-md transition-colors whitespace-nowrap"
            >
              {t('final_cta_main')}
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}